import { AscDataSourcesLayout, AscPathLoader } from '@neo.tax/asc/organisms';
import { Path } from '@neo.tax/shared';

import { useAscDataSourcesRedirect } from './hooks';

export const AscDataSources = (): React.ReactElement => (
  <AscPathLoader path={Path.ASC_DATA_SOURCES} useRedirect={useAscDataSourcesRedirect}>
    <AscDataSourcesLayout />
  </AscPathLoader>
);
